export const getOrder = state => state.checkout.order;
export const getOrderAcception = state => state.checkout.isOrderAccepted;
